import React, {Fragment} from 'react';
import {CircularProgress, Dialog} from "@mui/material";

/**
 * This code is a custom loader that uses a backdrop and a circular progress indicator. The loading prop determines whether the loader is displayed.
 * @param props The props for the component. The loading prop determines whether the loader is displayed. The loading prop is required.
 * @constructor
 *
 * A full example can be this:
 * <CustomLoader loading={loading}/>
 */

export interface CustomLoaderProps {
    loading: boolean;
}

const CustomLoader = ({loading}: CustomLoaderProps) => {
    if (loading) {
        return (
            <Fragment>
                <Dialog open={loading} sx={{
                    '& .MuiPaper-root': {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        overflow: 'hidden',
                    }
                }}>
                    <CircularProgress size={64}/>
                </Dialog>
            </Fragment>
        );
    } else {
        return null;
    }
};

export default CustomLoader;